import script from "./ElencoRilevazioni.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoRilevazioni.vue?vue&type=script&setup=true&lang=js"

import "./ElencoRilevazioni.vue?vue&type=style&index=0&id=74f15d13&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f15d13"]])

export default __exports__